/**
 * English Translations
 * All user-facing strings in English
 */

export default {
    cart: {
        empty: 'No products found',
        selectQuantity: 'Select quantity:',
        title: 'Shopping cart',
        close: 'Close cart',
        toCheckout: 'Go to checkout',
        done: 'Done',
        editCart: 'Edit cart',
        emptyCart: 'Empty cart',
        total: 'Total',
        goodsTotalExcl: 'Items (excl. shipping and discount)',
        giftCard: {
            to: 'To:',
            from: 'From:',
            message: 'Message:',
            physical: 'Physical card:',
            deliveryAddress: 'Delivery address:',
            yes: 'Yes'
        }
    },
    discount: {
        apply: 'Apply discount code',
        remove: 'Remove',
        validating: 'Validating discount code...',
        invalid: 'Invalid discount code',
        error: 'An error occurred while validating the discount code. Please try again.',
        alreadyApplied: 'Discount code already applied',
        applied: 'Discount code applied!',
        removed: 'Discount code removed',
        placeholder: 'Enter discount code',
        enterCode: 'Enter a discount code',
        noManualDiscount: 'No manual discount code to remove'
    },
    shipping: {
        loading: 'Loading shipping options...',
        error: 'Could not load shipping options. Please try again.',
        retry: 'Try again',
        free: 'Free',
        noOptions: 'No shipping options available at this time.',
        contactSupport: 'Contact customer service for help.',
        selectRequired: 'Please select a shipping option',
        methods: {
            PickUpStore: 'Pick up in store',
            Home: 'Home delivery',
            BoxReg: 'Box (registered)',
            BoxUnreg: 'Box (unregistered)',
            PickUpPoint: 'Pick-up point',
            Own: 'Own delivery',
            Postal: 'Postal service',
            DHLPackstation: 'DHL Parcel Station',
            Digital: 'Digital delivery'
        }
    },
    checkout: {
        emptyCart: 'No products in cart',
        fillRequired: 'Please fill in all required fields and accept the terms and conditions.',
        paymentError: 'Payment failed. Please try again.',
        paymentCancelled: 'Payment was cancelled or failed.',
        processing: 'Processing...',
        placeOrder: 'Place order',
        error: 'An error occurred during checkout. Please try again.',
        noItems: 'No items in cart',
        noCheckoutUrl: 'No checkout URL received from payment provider',
        initiateFailed: 'Could not initiate payment. Please try again.'
    },
    giftCardPayment: {
        apply: 'Use gift card',
        remove: 'Remove',
        validating: 'Validating gift card...',
        invalid: 'The gift card could not be used. Check the card number and PIN.',
        error: 'An error occurred while validating the gift card. Please try again.',
        enterCard: 'Enter card number and PIN',
        removed: 'Gift card removed',
        balanceLabel: 'balance',
        fullCoverageInfo: 'The gift card covers the entire order - no card payment is needed.',
        partialNotSupported: 'The gift card does not cover the entire order and cannot be combined with this payment method. Remove the gift card to continue.'
    },
    common: {
        subtotal: 'Subtotal',
        shipping: 'Shipping',
        discount: 'Discount',
        total: 'Total',
        yes: 'Yes',
        no: 'No',
        loading: 'Loading...',
        error: 'An error occurred',
        tryAgain: 'Try again'
    },
    giftCard: {
        defaultName: 'Gift Card',
        addedToCart: 'Added to cart!',
        validation: {
            recipientNameRequired: "Recipient's name is required",
            nameTooShort: 'Name must be at least 2 characters',
            emailRequired: 'Email address is required for digital gift cards',
            emailInvalid: 'Please enter a valid email address',
            senderNameRequired: "Sender's name is required",
            deliveryNameRequired: 'First name is required for physical cards',
            deliveryLastnameRequired: 'Last name is required for physical cards',
            deliveryAddressRequired: 'Address is required for physical cards',
            addressTooShort: 'Address must be at least 5 characters',
            deliveryZipRequired: 'Postal code is required for physical cards',
            zipInvalid: 'Postal code must be 5 digits',
            deliveryCityRequired: 'City is required for physical cards',
            cityTooShort: 'City must be at least 2 characters'
        },
        errors: {
            noProductId: 'Could not determine product ID',
            addToCartFailed: 'An error occurred when adding the gift card to cart'
        }
    }
};
